import { useParams } from "react-router-dom";

const ProductListScreen = () => {
    const { categoryName } = useParams();
    return <h1>ProductListScreen <br/> Show products for category {categoryName}</h1>;
  };
  
export default ProductListScreen;